import { render, staticRenderFns } from "./DoctorManage.vue?vue&type=template&id=85b858c8&scoped=true"
import script from "./DoctorManage.vue?vue&type=script&lang=js"
export * from "./DoctorManage.vue?vue&type=script&lang=js"
import style0 from "./DoctorManage.vue?vue&type=style&index=0&id=85b858c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b858c8",
  null
  
)

export default component.exports